import { Record as ImmutableRecord } from 'immutable'
import {
    AppEntitlementsAction,
    AppEntitlementsActions,
    AppEntitlementValue,
} from 'lib/actions/apps/app-entitlement'
import { AppEntitlementOwnersAction, AppEntitlementOwnersActions } from 'lib/actions/apps/app-entitlement-owners'
import { AppUserValue } from 'lib/actions/apps/app-users'
import { UserValue } from 'lib/actions/user'
import { initialDeleteReturn, initialEditReturn, initialGetReturn, initialListReturn } from 'lib/rpc'

export class AppEntitlementsState extends ImmutableRecord({
    list: initialListReturn<AppEntitlementValue>(),
    search: initialListReturn<AppEntitlementValue>(),
    item: initialGetReturn<AppEntitlementValue>(),
    listAppUsers: initialListReturn<AppUserValue>(),
    deleted: initialDeleteReturn(),
    ownersList: initialListReturn<UserValue>(),
    ownersEdit: initialEditReturn(),
    listForAppResource: initialListReturn<AppEntitlementValue>(),
}) { }

export const initialAppEntitlementsState: AppEntitlementsState = new AppEntitlementsState()

export const AppEntitlementsReducer = (
    state: AppEntitlementsState,
    action: AppEntitlementsActions | AppEntitlementOwnersActions,
): AppEntitlementsState => {
    switch (action.type) {
        case AppEntitlementsAction.search:
            return state.set('search', action.payload)
        case AppEntitlementsAction.get:
            return state.set('item', action.payload)
        case AppEntitlementsAction.update:
            return state.set('item', action.payload)
        case AppEntitlementOwnersAction.list:
            return state.set('ownersList', action.payload)
        case AppEntitlementOwnersAction.edit:
            return state.set('ownersEdit', action.payload)
        default:
            return state
    }
}
